import { useEffect, useState } from "react";
import api from "./api";

let cache = null;
let inflight = null;

export function bustAssets() {
  cache = null;
}

export function useAssets() {
  const [assets, setAssets] = useState(cache);
  useEffect(() => {
    if (cache) return;
    if (!inflight) {
      inflight = api
        .get("/assets")
        .then((r) => {
          cache = r.data;
          setAssets(r.data);
        })
        .catch(() => {})
        .finally(() => {
          inflight = null;
        });
    }
  }, []);
  return assets;
}

export function tourCover(assets, tour) {
  if (assets && assets.tours && assets.tours[tour.slug] && assets.tours[tour.slug].cover) {
    return assets.tours[tour.slug].cover;
  }
  return tour.images && tour.images[0];
}

export function tourGallery(assets, tour) {
  const a = assets && assets.tours && assets.tours[tour.slug];
  if (a && a.photos && a.photos.length) return a.photos;
  return tour.images || [];
}

export function tourMedia(assets, tour) {
  const a = (assets && assets.tours && assets.tours[tour.slug]) || {};
  return { photos: tourGallery(assets, tour), videos: a.videos || [], audio: a.audio || [] };
}

export function leaderPortrait(assets, leader) {
  if (leader.portrait) return leader.portrait;
  if (assets && assets.leaders && assets.leaders[leader.slug] && assets.leaders[leader.slug].portrait) {
    return assets.leaders[leader.slug].portrait;
  }
  return "";
}

export function leaderGallery(assets, leader) {
  const a = assets && assets.leaders && assets.leaders[leader.slug];
  if (a && a.photos && a.photos.length) return a.photos;
  return leader.gallery || [];
}

export function leaderMedia(assets, leader) {
  const a = (assets && assets.leaders && assets.leaders[leader.slug]) || {};
  return { photos: leaderGallery(assets, leader), videos: a.videos || [], audio: a.audio || [] };
}
